import { render, staticRenderFns } from "./IndexReview.vue?vue&type=template&id=2be9a9fa&scoped=true"
import script from "./IndexReview.vue?vue&type=script&lang=js"
export * from "./IndexReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9a9fa",
  null
  
)

export default component.exports